export enum EnumRoundTo{
    FINANCEIRO = 0,
    MATEMATICO = 1,
}